import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useHttp from '~/commons/hooks/useHttp';

import Board from '../layout/Board';

const ModalRedemption = ({ redeemed, level }) => {
  const { i18n, t } = useTranslation();
  const [show, setShow] = useState(false);
  const { req, res } = useHttp();
  const disabled = redeemed || res.status;

  return (
    <>
      <button
        type="button"
        className="btn"
        onClick={() => setShow(true)}
        disabled={disabled}
      >
        <img
          alt="reward"
          src={`/assets/img/btn-reward${disabled ? '-disabled' : ''}${i18n.language === 'en' ? '' : '-chi'}.png`}
          style={{ maxWidth: '140px' }}
        />
      </button>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
        contentClassName="modal-no-bg"
      >
        <Board>
          <div className="text-center">
            {t('pg.game.reward.msg', { returnObjects: true }).map((s, i) => (
              <h6 key={i}>{s}</h6>
            ))}
            {t('pg.game.reward.note', { returnObjects: true }).map((s, i) => (
              <h6 key={i} style={{ color: '#C97B3A' }}>{s}</h6>
            ))}
            <div className="mt-3">
              <button
                className="btn btn-rock-3 fontBorder me-3"
                type="button"
                onClick={() => setShow(false)}
              >
                {t('cancel', 'Cancel')}
              </button>
              <button
                className="btn btn-rock-3 fontBorder"
                type="button"
                onClick={() => {
                  setShow(false);
                  req({
                    url: '/api/users/redeem-reward',
                    method: 'post',
                    data: {
                      level: level._id,
                      lang: i18n.language,
                    },
                  });
                }}
              >
                {t('confirm', 'Confirm')}
              </button>
            </div>
          </div>
        </Board>
      </Modal>
    </>
  );
};

export default ModalRedemption;
